<div class="form-group" [ngClass]="{ 'inline-flex': buttonLabel.length > 0 }">
  <label [for]="label" class="mr-3 mb-0 input-text-font" *ngIf="label.length > 0">
    {{ label }}
    <span *ngIf="required && label" class="color-red" title="Required">*</span>
    <span *ngIf="note" class="note ml-3">{{ note }}</span>
  </label>

  <label *ngIf="buttonLabel.length > 0" class="mr-2 mb-0 mt-1 default-font">{{ buttonLabel }}</label>
  <div *ngFor="let option of options; index as i">
    <label class="option-label" [for]="id + i" [ngClass]="{ 'form-check-inline': option.label.length > 0 }">
      <input
        *ngIf="!option.disabled"
        class="option-input"
        [type]="type"
        [id]="id + i"
        [name]="id"
        [tabIndex]="i"
        value="option.value"
        [checked]="option.selected"
        [formControl]="control"
        (change)="onValueChanged(option)"
        [ngClass]="{ required: control.errors?.['required'] === true }"
      />
      <input
        *ngIf="option.disabled"
        class="option-input disabled"
        [type]="type"
        [id]="id + i"
        [name]="id"
        [tabIndex]="i"
        value="option.value"
        [checked]="option.selected"
        [ngClass]="{ required: control.errors?.['required'] === true }"
        disabled
      />{{ option.label }}
    </label>
  </div>
  <div *ngIf="type === 'toggle'">
    <div class="custom-control custom-switch align-toggle">
      <input type="checkbox" class="custom-control-input" [id]="id" [formControl]="control" (change)="onChanged()" />
      <label class="custom-control-label option-input" [for]="id">{{ optionLabel }}</label>
    </div>
  </div>
</div>
